import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import CourseFunServices from "./CoursesFun.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCourseFun = (filters) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_COURSEFUNCION,
        payload: true,
      });
      const resp = await CourseFunServices.getCourseFun(filters);
      dispatch({
        type: actions.GET_COURSEFUNCION,
        payload: {
          coursesFuncion: resp.data.data,
          coursesFuncionLength: resp.data.count,
        },
        
      });
      
      dispatch({
        type: actions.COURSEFUNCION_FAIL,
        payload: "",
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.COURSEFUNCION_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_COURSEFUNCION,
        payload: false,
      });
    }


  };
  
  export const searchCourseFun = (filters)=> async (dispatch)=>{
    try {
      dispatch({
        type: actions.LOADING_COURSEFUNCION,
        payload: true,
      });
      const resp = await CourseFunServices.getCourseFun(filters);
      dispatch({
        type: actions.GET_COURSEFUNCION,
        payload: {
          coursesFuncion: resp.data.data,
          coursesFuncionLength: resp.data.count,
        },
        
      });
      
      dispatch({
        type: actions.COURSEFUNCION_FAIL,
        payload: "",
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.COURSEFUNCION_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_COURSEFUNCION,
        payload: false,
      });
    }

  };

  export const getCourse = (filters) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_COURSE,
        payload: true,
      });
      const resp = await CourseFunServices.getCourse(filters);
      dispatch({
        type: actions.GET_COURSE,
        payload: {
          courses: resp.data.data,
          coursesLength: resp.data.count,
        },
      });
      dispatch({
        type: actions.COURSE_FAIL,
        payload: "",
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.COURSE_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_COURSE,
        payload: false,
      });
    }
  };
  
  export const getCourseById = (id) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_COURSE,
        payload: true,
      });
      const resp = await CourseFunServices.getCourseByID(id);
      dispatch({
        type: actions.GET_COURSE,
        payload: {
          courses: resp.data,
        },
      });
      dispatch({
        type: actions.COURSE_FAIL,
        payload: "",
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.COURSE_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_COURSE,
        payload: false,
      });
    }
  };  
  
  export const getTasks = (params) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_TASK,
        payload: true
      });
      const resp = await CourseFunServices.getTasks(params, 1);
      dispatch({
        type: actions.GET_TASKS,
        payload: {
          tasks: resp.data.data,
          tasksLength: resp.data.count
        }
      });
      dispatch({
        type: actions.TASK_FAIL,
        payload: "",
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.TASK_FAIL,
        payload: message,
      });
    }finally{
      dispatch({
        type: actions.LOADING_TASK,
        payload: false
      });
    }
  }
  export const saveCourseFun =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      
      dispatch({
        type: actions.SAVE_LOADING_COURSEFUNCION,
        payload: true,
      });
      const resp = await CourseFunServices.saveCourseFun(data);

      debugger
      const { coursesFuncion, coursesFuncionLength } = getState().cursosFuncion;
      const _coursesFuncion = [...coursesFuncion, resp.data];
      dispatch({
        type: actions.GET_COURSEFUNCION,
        payload: {
          coursesFuncion: _coursesFuncion,
          coursesFuncionLength: coursesFuncionLength + 1,
          
        },
        
        
      });
      
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
        
      })
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_COURSEFUNCION,
        payload: false,
      });
    }
  };

  export const editCourseFun =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      
      dispatch({
        type: actions.LOADING_COURSEFUNCION,
        payload: true,
      });
      const resp = await CourseFunServices.editCourseFun(id, data);

      const { coursesFuncion, coursesFuncionLength } = getState().cursosFuncion;
      coursesFuncion[index] = resp.data;
      dispatch({
        type: actions.GET_COURSEFUNCION,
        payload: {
          coursesFuncion: coursesFuncion,
          coursesFuncionLength: coursesFuncionLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_COURSEFUNCION,
        payload: false,
      });
    }
  };

  export const deleteCourseFun = (id, index) => async (dispatch, getState) => {
      try {
       
        dispatch({
          type: actions.LOADING_COURSEFUNCION,
          payload: true,
        });
        await CourseFunServices.deleteCourseFun(id);
        debugger
        const { coursesFuncion, coursesFuncionLength } = getState().cursosFuncion;
        coursesFuncion.splice(index, 1);
        
        dispatch({
          type: actions.GET_COURSEFUNCION,
          payload: {
            coursesFuncion: coursesFuncion,
            coursesFuncionLength: coursesFuncionLength - 1,
          },
        });
        dispatch({
          type: actions.COURSEFUNCION_FAIL,
          payload: "",
        });
    
        toastr.success(messages.successMessage, " ", {
          progressBar: true,
          rtl: true,
        });
      } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
          if (ex.response?.status) {
            switch (ex.response.status) {
              case 400:
                message = messages.errorMessage + " " + ex.response.statusText;
                break;
              case 404:
                message = messages.errorMessage + " " + ex.response.statusText;
                break;
              case 500:
                message = messages.errorMessage + " " + ex.response.statusText;
                break;
              default:
                message = ex.response.data;
                break;
            }
          } else {
            message =
              ex.message === "Network Error" ? messages.networkError : ex.message;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
    
        dispatch({
          type: actions.COURSEFUNCION_FAIL,
          payload: message,
        });
      } finally {
        dispatch({
          type: actions.LOADING_COURSEFUNCION,
          payload: false,
        });
      }
    };
    